module.exports = __webpack_public_path__ + "img/nt112-02-85-1.prt.9aad0584.jpg";